module.exports = __webpack_public_path__ + "img/person.ad4458c1.png";